import { createRequest } from '@shared/services';

export async function getCart() {
    const request = createRequest<GetCartResponse>({
        url: '/cart',
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function getCartCount() {
    const request = createRequest<GetCartCountResponse>({
        url: '/cart/count',
        method: 'GET',
        withAuthorization: true,
        useToastHandler: false,
    });

    return request.execute();
}

export async function getCartAutoFill() {
    const request = createRequest<GetCartAutoFillResponse>({
        url: '/cart/auto-fill',
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function postCart(
    payload: BuyerAddToCartPayload | Array<BuyerAddToCartPayload>
) {
    const request = createRequest<PostCartResponse>({
        url: '/cart',
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function postCartOrderGiveaway(payload: BuyerAddToCartOrderGiveawayPayload) {
    const request = createRequest<PostCartResponse>({
        url: '/cart/order-giveaway',
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putCart(payload: BuyerUpdateToCartPayload, cart_id: string) {
    const request = createRequest<PostCartResponse>({
        url: `/cart/${cart_id}`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

interface DeleteCartPayload {
    cart_id: string;
}

export async function deleteCart(payload: DeleteCartPayload) {
    const { cart_id } = payload;

    const request = createRequest<BasicSuccessResponse>({
        url: `/cart/${cart_id}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}
